const TENANTS = {
    chambeshi : 'Chambeshi Water and Sanitation Company',
    chambeshi2 : 'Customer Service Contact: ',
    kafubu : 'Kafubu Water and Sanitation was established in the year 2000 under the local authorities on the Copperbelt Province of the Republic of Zambia. The head office is in the City of Ndola, the municipality of Luanshya and Masaiti District in accordance with the water and supply and sanitation act. no. 28 of 1997.',
    kafubu2 : 'Customer Service Contact: +260950666130',
    lukanga : 'Lukanga Water and Sanitation was established to improve delivery of Water Supply, Sewerage and Sanitation Services to the Urban and Peri-urban population in Central Province.',
    lukanga2: 'Customer Service Contact: +260 215 222474',
    mazabuka : 'Mazabuka Municipal Council',
    mazabuka2 : 'Customer Service Contact: ',
    nkana: 'Nkana Water and Sanitation Compnay',
    nkana2 : 'Customer Service Contact: ',
    swasco:'Southern Water Water and Sanitation Compnay',
    swasco2 : 'Customer Service Contact: ',

    wizard : 'Mazabuka Municipal Council',
    wizard2 : 'Customer Service Contact: ',

    scl : 'Powered by eFectivo Innovations Ltd. Email: info@smartconcept.co.zm mobile: +260978868361'
}

export default TENANTS